<template>
  <div class="popup-notification" :class="typeClass">
    <div class="popup-content">
      <!-- <div class="popup-icon">
        <vue-fontawesome :icon="icon" />
      </div> -->
      <div class="popup-message">
        <h4 v-if="title" class="popup-title">{{ title }}</h4>
        <p>{{ message }}</p>
      </div>
      <div v-if="count > 1" class="popup-count">{{ count }}</div>
      <button class="popup-close" @click="closeNotification">
        <vue-fontawesome icon="times" />
      </button>
    </div>
    <div class="popup-progress" :style="{ width: progress + '%' }"></div>
  </div>
</template>

<script>
export default {
  name: 'StackedPopupNotification',
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'info', // success, warning, error, info
      validator: value =>
        ['success', 'warning', 'error', 'info'].includes(value),
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      default: 5000, // 5 seconds
    },
    count: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      progress: 100,
      timer: null,
    }
  },
  computed: {
    typeClass() {
      return `popup-${this.type}`
    },
    icon() {
      switch (this.type) {
        case 'success':
          return 'check-circle'
        case 'warning':
          return 'exclamation-circle'
        case 'error':
          return 'times-circle'
        default:
          return 'info-circle'
      }
    },
  },
  mounted() {
    if (this.duration > 0) {
      this.startTimer()
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    startTimer() {
      const startTime = Date.now()
      const endTime = startTime + this.duration

      this.timer = setInterval(() => {
        const now = Date.now()
        const remaining = endTime - now

        if (remaining <= 0) {
          this.progress = 0
          clearInterval(this.timer)
          this.closeNotification()
        } else {
          this.progress = (remaining / this.duration) * 100
        }
      }, 10)
    },
    closeNotification() {
      // When closing, we remove all notifications of this type
      this.$emit('close', this.type)
    },
  },
}
</script>

<style scoped lang="scss">
.popup-notification {
  position: relative;
  width: 350px;
  margin-bottom: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  transform: translateX(0);
  transition: all 0.3s ease-in-out;
  font-family: 'Nunito Sans', sans-serif;

  &.popup-success {
    background-color: #f6ffed;
    border: 1px solid #b7eb8f;

    .popup-icon {
      color: #52c41a;
    }

    .popup-progress {
      background-color: #52c41a;
    }
  }

  &.popup-warning {
    background-color: #fffbe6;
    border: 1px solid #ffe58f;

    .popup-icon {
      color: #faad14;
    }

    .popup-progress {
      background-color: #faad14;
    }
  }

  &.popup-error {
    background-color: #fff2f0;
    border: 1px solid #ffccc7;

    .popup-icon {
      color: #ff4d4f;
    }

    .popup-progress {
      background-color: #ff4d4f;
    }
  }

  &.popup-info {
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;

    .popup-icon {
      color: #1890ff;
    }

    .popup-progress {
      background-color: #1890ff;
    }
  }
}

.popup-content {
  display: flex;
  align-items: flex-start;
  padding: 16px;
}

.popup-icon {
  font-size: 20px;
  margin-right: 12px;
  margin-top: 2px;
}

.popup-message {
  flex: 1;

  .popup-title {
    margin: 0 0 4px 0;
    font-size: 16px;
    font-weight: 600;
    color: #000000d9;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #000000d9;
    line-height: 1.4;
  }
}

.popup-count {
  background-color: #ff4d4f;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  margin-right: 8px;
}

.popup-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 16px;
  padding: 0;
  margin-left: 12px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #00000073;
  }
}

.popup-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  transition: width 0.1s linear;
}
</style>
